import { render, staticRenderFns } from "./GroupHead.vue?vue&type=template&id=5aeb7421&scoped=true&lang=pug&"
import script from "./GroupHead.vue?vue&type=script&lang=js&"
export * from "./GroupHead.vue?vue&type=script&lang=js&"
import style0 from "./GroupHead.vue?vue&type=style&index=0&id=5aeb7421&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aeb7421",
  null
  
)

export default component.exports